'use strict';
var cloModal, isObject, setPayload, setPictureSources, setSiteCookies, tracky, wasShown;

setSiteCookies = require('../../../../core/frontend/groupon_modules/setSiteCookies');

tracky = require('../../../../src/frontend/helper/general/m_trackEvent');

setPictureSources = require('../../../../src/frontend/helper/general/m_setPictureSources').setPictureSources;

isObject = require('../../../../src/frontend/helper/general/m_underscore_replacements').isObject;


/**
 * Determine if modal was shown in current division
 *
 * @param   {String}  currentDivision
 * @param   {String}  namespace       - Current storage / cookie name
 * @returns {Boolean}
 */

wasShown = function(currentDivision, namespace) {
  var divisionMap;
  if (!currentDivision) {
    return true;
  }
  try {
    divisionMap = JSON.parse((typeof localStorage !== "undefined" && localStorage !== null ? localStorage.getItem(namespace) : void 0) || Cookie.get(namespace) || '{}');
    return !!divisionMap[currentDivision];
  } catch (error) {
    return false;
  }
};


/**
 * Update & set payload
 *
 * @param   {String} currentDivision
 * @param   {String} namespace       - Current storage / cookie name
 * @returns {String}                 - Stringified payload
 */

setPayload = function(currentDivision, namespace) {
  var payload;
  payload = (function() {
    try {
      return JSON.parse((typeof localStorage !== "undefined" && localStorage !== null ? localStorage.getItem(namespace) : void 0) || Cookie.get(namespace) || '{}');
    } catch (error) {
      return {};
    }
  })();
  if (!isObject(payload)) {
    payload = {};
  }
  payload[currentDivision] = true;
  return JSON.stringify(payload);
};


/*
 *  LS-3374 - GTG (GrouponToGo) modal shared code across desktop / touch / m2016
 */

cloModal = {
  init: function() {
    var $html, $modal, $modalAndWrapper, $picture, $redirectBtn, $wrapper, alt_image, cb, currentDivision, links, namespace, patchedHref, picture, ref, ref1, ref2, usr;
    namespace = 'gtg_modal';
    currentDivision = ((ref = Groupon.division) != null ? ref.id : void 0) || '';
    links = (ref1 = Groupon.LS.data) != null ? (ref2 = ref1.cloModal) != null ? ref2.images : void 0 : void 0;
    if (wasShown(currentDivision, namespace)) {
      return;
    }
    if (!($modal = $('#ls-gtg-modal')).length) {
      return;
    }
    if (!(links && links.length)) {
      return;
    }
    $wrapper = $('#ls-modals-wrapper');
    $html = $('html');
    $modalAndWrapper = $wrapper.add($modal);
    picture = '<picture id="ls-gtg-image"><img class="ls-gtg-teaser"/></picture>';
    $picture = $(picture);
    alt_image = Groupon.LS.translations.myStuff.gtg.image_alt;
    cb = function() {
      $modalAndWrapper.removeClass('ls-hide');
      return $html.addClass('blockContentScrolling');
    };
    setPictureSources($picture, links, $modal, alt_image, cb);
    $modal.on('click', function(e) {
      e.preventDefault();
      return e.stopImmediatePropagation();
    });
    $redirectBtn = $('.ls-gtg-redirect');
    usr = Cookie.get('snickerdoodle') || '';
    patchedHref = $redirectBtn.attr('href').replace(/{division}/g, Groupon.division.id).replace(/{user}/g, usr);
    $redirectBtn.attr('href', patchedHref);
    return $wrapper.add('.ls-gtg-content a').one('click', function(e) {
      var bhw, cookie, payload;
      bhw = $(e.currentTarget).data('bhw');
      if (bhw !== 'closignup') {
        bhw = 'clonothanks';
      }
      tracky(bhw);
      $modal.off('click');
      e.stopImmediatePropagation();
      payload = setPayload(currentDivision, namespace);
      if (localStorage) {
        if (typeof localStorage !== "undefined" && localStorage !== null) {
          localStorage.setItem(namespace, payload);
        }
      } else {
        cookie = {};
        cookie[namespace] = payload;
        setSiteCookies(cookie, 60 * 60 * 24 * 30);
      }
      $modalAndWrapper.addClass('ls-hide');
      return $html.removeClass('blockContentScrolling');
    });
  }
};

module.exports = {
  cloModal: cloModal,
  setPayload: setPayload,
  wasShown: wasShown
};

